// import Cookies from 'js-cookie'
import { useBrowserfunctions } from '../../libs/Browser'

const { selectLanguageWithFallback } = useBrowserfunctions()

const locales = ['nl', 'en', 'it']
const languages = [
  { flag: 'nl', language: 'nl', title: 'Nederlands' },
  { flag: 'gb', language: 'en', title: 'English' },
  { flag: 'it', language: 'it', title: 'Italiano' }
]

/*
* De Browser bepaalt de standaard taal, dus locale wordt geinitialiseerd met de browsertaal
* Maar de gebruiker kan gewooon switchen via de vlaggetjes. PDF wordt gemaakt obv state.locale
* */
const fallback = 'en'
const locale = selectLanguageWithFallback(languages.map(l => l.language), fallback)

const lang = {
    namespaced: true,
    // state
    state: {
      locale: locale,
      locales: locales,
      languages: languages,
      fallback: fallback
    },

    // getters
    getters: {
      locale: state => state.locale,
      locales: state => state.locales,
      languages: state => state.languages,
      fallback: state => state.fallback
    },

    // mutations
    mutations: {
      SET_LOCALE (state, { locale }) {
        state.locale = locale
      }
    },

    // actions
    actions: {
      setLocale ({ commit }, { locale }) {
        commit('SET_LOCALE', { locale })

        // Cookies.set('locale', locale, { expires: 365 })
      }
    }

}

export default lang
